import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Components/Header";
import Home from "./Components/Pages/Home";
import AboutUs from "./Components/Pages/AboutUs";
import Services from "./Components/Pages/Services";
import EstablishmentCompliance from "./Components/Pages/Services/establishment-compliance";
import FactoryCompliance from "./Components/Pages/Services/factory-compliance";
import ContractLabourCompliance from "./Components/Pages/Services/contract-labour-compliance";
import PayrollServices from "./Components/Pages/Services/payroll-services";
import PayrollCompliance from "./Components/Pages/Services/payroll-compliance";
import IndustrialLicensing from "./Components/Pages/Services/industrial-licensing";
import ComplianceAuditConsulting from "./Components/Pages/Services/compliance-audit-consulting";
import InspectionHandling from "./Components/Pages/Services/inspection-handling";
import ComplianceLegalServices from "./Components/Pages/Services/compliance-legal-services";
import Products from "./Components/Pages/Products";
import Hsquare from "./Components/Pages/Products/Hsquare";
import Rcube from "./Components/Pages/Products/Rcube";
import VRIC from "./Components/Pages/Products/VRIC";
import LitigationModule from "./Components/Pages/Products/LitigationModule";

import Resource from "./Components/Pages/Resources";
import WhyUs from "./Components/Pages/WhyUs";

import ContactUs from "./Components/Pages/ContactUs";
import Careers from "./Components/Pages/Careers";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);          // Force scroll to top
    // Optional: smoother scroll (if you prefer)
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}


function App() {
  return (
    <div className="bg-gray-50 min-h-screen">
      
      {/* Header */}
      <Header />

    <ScrollToTop />

      {/* Pages */}
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/establishment-compliance" element={<EstablishmentCompliance />} />
          <Route path="/services/factory-compliance" element={<FactoryCompliance />} />
          <Route path="/services/contract-labour-compliance" element={<ContractLabourCompliance />} />
          <Route path="/services/payroll-services" element={<PayrollServices />} />
          <Route path="/services/payroll-compliance" element={<PayrollCompliance />} />
          <Route path="/services/industrial-licensing" element={<IndustrialLicensing />} />
          <Route path="/services/compliance-audit-consulting" element={<ComplianceAuditConsulting />} />
          <Route path="/services/inspection-handling" element={<InspectionHandling />} />
          <Route path="/services/compliance-legal-services" element={<ComplianceLegalServices />} />

          <Route path="/products" element={<Products />} />
          <Route path="/products/hsquare" element={<Hsquare />} />
          <Route path="/products/rcube" element={<Rcube />} />
          <Route path="/products/vric" element={<VRIC />} />
          <Route path="/products/litigationmodule" element={<LitigationModule />} />

          <Route path="/resources" element={<Resource />} />
          <Route path="/whyus" element={<WhyUs />} />
          
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />




          
          <Route path="/about" element={<AboutUs />} />
        </Routes>
      </main>

    </div>
  );
}

export default App;